const sys = require("_js/sys.js");
const logger = require("_js/logger.js");
const ua = require("_js/useragent.js");

let preloader;

const PRELOADER_CONFIGS = {
	215: {default: "ABXPreloaderLoader"},
	210: {default: "ABXPreloaderLoader"},
	190: {default: "ABXPreloaderLoader"},
	240: {default: "InrivalPreloaderLoader"},
	250: {
		default: "ManoboPreloaderLoader",
		rules: [
			{startWith: "r7", preloader: "RevionPreloaderLoader"}
		]
	}
};

export function loadAndStartPreloader() {
	const path = `${sys.params.path}preloader`;

	return new Promise((resolve, reject) => {
		try {
			sys.loadScript(`${path}/preloader.min.js?rnd=${Math.random()}`)
				.catch((error) => {
					logger.error(error);

					reject();
				}
				)
				.then(() => {
					const cb = () => {
						resolve();
					};

					const preloaderName = getPreloaderNameBySupp(sys.params.game.supp, sys.params.game_id);

					if (window.customPreloader[preloaderName]) {
						preloader = new window.customPreloader[preloaderName]({isDesktop: ua.isDesktop});

						preloader.start(path, cb);
					} else {
						reject();
					}
				});
		} catch (error) {
			logger.error(error);

			reject();
		}
	});
}

function getPreloaderNameBySupp(supp, gameName = "") {
	if (Array.isArray(supp)) {
		const firstOccuredSupp = supp.find((targetSupp) => Object.keys(PRELOADER_CONFIGS).includes(targetSupp));

		return getPreloaderNameByConfig(PRELOADER_CONFIGS[firstOccuredSupp], gameName);
	}

	return getPreloaderNameByConfig(PRELOADER_CONFIGS[supp], gameName);
}

function getPreloaderNameByConfig(suppConfig, gameName = "") {
	if (Array.isArray(suppConfig.rules)) {
		for (const rule of suppConfig.rules) {
			if (rule.startWith && gameName.startsWith(rule.startWith)) {
				return rule.preloader;
			}
		}
	}

	return suppConfig.default;
}

export function destroyPreloader() {
	if (preloader) {
		preloader.destroy();
	}
}


// WEBPACK FOOTER //
// ./js/preloader.js